import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	emptyStatePlaceholderLabel: {
		id: 'company-hub.company-hub-common.ui.empty-state.label-placeholder',
		defaultMessage: 'LABEL',
		description: 'Placeholder label that is displayed when no label is provided',
	},
});
